import { GET_NEWS_REFRESH_MAP } from "./actions.type";

import { SET_LOADING, SET_NEWS_REFRESH_MAP } from "./mutations.type";

import { MODULE_PREFIX_HOME } from "@/store";

const STATE = {
  news: {
    features: [],
    total: null,
    refreshMap: false,
    enabled: false,
    params: {
      timestamp: null,
    },
  },
};

const GETTERS = {
  news: (state) => state.news,
};

const ACTIONS = {
  [GET_NEWS_REFRESH_MAP](context, params) {
    context.commit(MODULE_PREFIX_HOME + SET_LOADING, params, { root: true });
    context.commit(SET_NEWS_REFRESH_MAP, params);
  },
};

const MUTATIONS = {
  [SET_NEWS_REFRESH_MAP](state, data) {
    state.news.refreshMap = data ? new Date().toISOString() : false;
  },
  [SET_LOADING](state, data) {
    state.detailsSidebar.loading = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
